const Spinner = {
  show() {
    document.getElementById("global-spinner")?.classList.remove("hidden");
  },
  hide() {
    document.getElementById("global-spinner")?.classList.add("hidden");
  },
};
//Spinner.show();  // Show the spinner
//Spinner.hide();  // Hide the spinner

function triggerDrawer() {
  const drawerComponent = document.querySelector("header-drawer");
  const detailsEl = drawerComponent?.querySelector("details");
  const summary = drawerComponent?.querySelector("summary");

  if (drawerComponent && summary && detailsEl) {
    // Add transition class first

    detailsEl.setAttribute("open", "");

    // Slight delay before setting 'open' attribute so transition can kick in
    setTimeout(() => {
      // Use Shopify's built-in function to ensure accessibility features work
      drawerComponent.openMenuDrawer(summary);

      // Add the open attribute manually (if needed)
      detailsEl.classList.add("menu-opening");
    }, 10); // 10ms is enough for CSS to register the transition class
  }
}

function closeDrawer() {
  const detailsEl = document.querySelector("#Details-menu-drawer-container");

  if (!detailsEl) return;

  //console.log("closeDrawer inside theme.js");

  //document.body.classList.remove('overflow-hidden-tablet');
  removeOverflowHiddenClasses();

  // Add closing animation class (optional)
  detailsEl.classList.remove("menu-opening"); // triggers reverse animation if needed

  // Wait for the transition to complete before removing `open`
  const transitionDuration = 300; // Match this with your --duration-default in CSS

  setTimeout(() => {
    detailsEl.removeAttribute("open");
  }, transitionDuration); // delay matches the CSS transition
}

function removeOverflowHiddenClasses() {
  document.body.className = document.body.className
    .split(" ")
    .filter((className) => !className.startsWith("overflow-hidden-"))
    .join(" ");
}

//Newsletter Popup Code
function toggleLoadingIndicator(show) {
  $("#loading-indicator").css("display", show ? "flex" : "none");
}

// Newsletter popup trigger
$(".product-information-show-newsletter-popup").on("click", () => {
  $(".newsletter-popup-overlay, .newsletter-popup-stage-signup").show();
});

// Scroll-triggered popup logic
const $popup = $(".newsletter-popup-stage-signup");
if ($popup.length) {
  const data = $popup.data();

  if (data.showByScroll) {
    const showPoint =
      document.body.scrollHeight * (parseInt(data.scrollPosition) / 100);
    let popupShown = false;

    $(window).on("scroll", () => {
      if (!popupShown && $(window).scrollTop() > showPoint) {
        $(".newsletter-popup-overlay, .newsletter-popup-stage-signup").show();
        popupShown = true;
      }
    });
  }
}

// Newsletter form submission
$("#newsletter-popup-form").on("submit", function (e) {
  e.preventDefault();

  $(".newsletter-popup-error").hide();

  const email = $(this).find('input[name="contact[email]"]').val();
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!email || !email.toLowerCase().match(emailRegex)) {
    $(".newsletter-popup-error").css("display", "inline-block");
    return;
  }

  toggleLoadingIndicator(true);

  $.ajax({
    type: "POST",
    url: $(this).attr("action"),
    data: $(this).serialize(),
    dataType: "json",
    complete: () => {
      toggleLoadingIndicator(false);
      $(".newsletter-popup-stage-signup").hide();
      $(".newsletter-popup-stage-success").show();
    },
  });
});

// Close popup on overlay or close button click
$(".newsletter-popup-overlay, .newsletter-popup-close").on("click", () => {
  $(".newsletter-popup-overlay, .newsletter-popup").hide();
});

//Scrolling Image
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".scrolling-image").forEach((container) => {
    const speed = parseInt(container.dataset.scrollingSpeed) || 20;
    const scrollContainer = container.querySelector(
      ".scrolling-image__container"
    );
    const duration = `${(100 / speed) * 20}s`; // Lower speed = longer duration
    scrollContainer.style.animationDuration = duration;
  });
});

//Sticky add to cart button action
document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("#sticky-add-to-cart form");
  const button = document.querySelector("#sticky-add-to-cart .button");

  if (!form || !button) return;

  // Variant change handler
  form.querySelectorAll("select").forEach((select) => {
    select.addEventListener("change", () => {
      const options = Array.from(form.querySelectorAll("select")).map(
        (select) => ({
          name: select.name,
          value: select.value,
        })
      );

      const productData = window.meta && window.meta.product;
      if (!productData || !productData.variants) {
        console.warn("Product data not found.");
        return;
      }

      const variant = productData.variants.find((v) =>
        options.every((opt, idx) => v[`option${idx + 1}`] === opt.value)
      );

      if (!variant) {
        console.warn("Variant not found.");
        button.disabled = true;
        return;
      }

      form.querySelector('input[name="id"]').value = variant.id;
    });
  });

  // Add to cart submission handler
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    if (button.disabled) return;

    const formData = new FormData(form);

    // Get the default submit button text and store it
    const defaultBtnText = button.innerHTML;

    button.disabled = true;
    button.textContent = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then((data) => {
        button.textContent = "Added!";
        //console.log("Data", data);

        return fetch("/cart?section_id=cart-icon-bubble");
      })
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const updatedBubble = doc.querySelector(".shopify-section");

        if (updatedBubble) {
          const target = document.querySelector(
            "#cart-icon-bubble .shopify-section"
          );
          if (target) {
            target.innerHTML = updatedBubble.innerHTML;
          } else {
            const fallback = document.getElementById("cart-icon-bubble");
            if (fallback) fallback.innerHTML = updatedBubble.innerHTML;
          }
        }

        if (typeof reInitCartDrawer === "function") reInitCartDrawer();

        // 🔓 Open the Dawn theme cart drawer
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && typeof cartDrawer.open === "function") {
          cartDrawer.classList.remove("is-empty");
          cartDrawer.open(); // ✅ This is the correct way in Dawn theme
        } else {
          console.warn("Cart drawer not found or open method unavailable.");
        }
      })
      .catch((err) => {
        alert("Error adding to cart.");
        console.error(err);
      })
      .finally(() => {
        setTimeout(() => {
          button.disabled = false;
          button.innerHTML = defaultBtnText;
        }, 1500);
      });
  });
});

// Sticky add to cart button.
if ($("#sticky-add-to-cart").length > 0) {
  const $sticky = $("#sticky-add-to-cart");
  const $header = document.querySelector(".header-wrapper");

  if ($sticky.attr("data-position") === "top") {
    let headerHeight = 0;

    if ($header instanceof HTMLElement) {
      const stickyType = $header.getAttribute("data-sticky-type");

      if (stickyType === "always" && window.innerWidth > 767) {
        headerHeight = $header.offsetHeight;
        //console.log('Sticky type is "always" and screen is wider than 767px.');

        $sticky.css({
          position: "fixed",
          top: `${headerHeight}px`,
          bottom: "auto",
          width: "100%",
          zIndex: 9999,
        });
      } else if (!$header.hasAttribute("data-sticky-type")) {
        //console.log( 'Header exists but "data-sticky-type" attribute is missing.' );

        $sticky.css({
          position: "fixed",
          top: "0px",
          bottom: "auto",
          width: "100%",
          zIndex: 9999,
        });
      } else if (stickyType === "on-scroll-up" && window.innerWidth > 767) {
        //console.log( 'Sticky type is "on-scroll-up" and screen is wider than 767px.' );

        let lastScrollTop = 0;
        const fullHeaderHeight = $header.offsetHeight;

        window.addEventListener("scroll", function () {
          const st = window.pageYOffset || document.documentElement.scrollTop;
          headerHeight = st > lastScrollTop ? 0 : fullHeaderHeight;
          lastScrollTop = Math.max(st, 0);

          $sticky.css({
            position: "fixed",
            top: `${headerHeight}px`,
            bottom: "auto",
            width: "100%",
            zIndex: 9999,
          });
        });
      } else {
        //console.log("Condition not met.");
      }
    } else {
      console.warn("Header not found or not an element:", $header);
    }
  }

  setTimeout(() => {
    const $cartBtn = $('[id^="ProductSubmitButton"]');
    //const $cartBtn = $("#ProductSubmitButton-SingleProduct");
    let scrollTopCartButton = 0;

    if ($cartBtn.length > 0) {
      scrollTopCartButton = $cartBtn.offset().top;
    }

    const showType = $sticky.attr("data-show-type");
    const showPercentage =
      parseInt($sticky.attr("data-show-type-percentage")) || 0;

    if (showType === "percentage") {
      scrollTopCartButton =
        document.documentElement.scrollHeight * (showPercentage / 100);
    }

    $(window).on("scroll", function () {
      const scrollTop = $(this).scrollTop();

      // Show when scroll passes target point
      if (showType === "cart_button" || showType === "percentage") {
        if (scrollTop > scrollTopCartButton) {
          $sticky.fadeIn(150);
        } else {
          $sticky.fadeOut(150);
        }
      }

      // Show when original cart button is out of view
      if (showType === "cart_button_hide" && $cartBtn.length) {
        const rect = $cartBtn[0].getBoundingClientRect();
        const isOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;

        if (isOutOfView) {
          $sticky.fadeIn(150);
        } else {
          $sticky.fadeOut(150);
        }
      }
    });
  }, 100);
}

//Sticky add to  cart code end

//Product Grid -Product Loop Add To Cart With Variants via Ajax - quick add/quick-add

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll('form[data-type="add-to-cart-form"]')
    .forEach(function (form) {
      const productIdElement = form.querySelector('[name="productid"]');
      if (productIdElement) {
        const productId = productIdElement.value;
        console.log("Product ID:", productId);

        //const productId = form.querySelector('[name="productid"]').value;
        const variantInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const qtyDisplay = form.querySelector(
          ".product-information-quantity-input"
        );
        const plusBtn = form.querySelector('button[name="plus"]');
        const minusBtn = form.querySelector('button[name="minus"]');
        const submitBtn = form.querySelector('button[type="submit"]');
        const cartType = submitBtn.getAttribute("data-cart-type");

        // Get the product JSON object (ensure it exists)
        const productJson = window["th_product_" + productId];
        if (!productJson || !productJson.variants) return;

        // Update variant when selects change
        const updateVariant = () => {
          const selectedOptions = Array.from(
            form.querySelectorAll(
              ".card__product-form-variant_container select"
            )
          ).map((select) => select.value);

          const matchedVariant = productJson.variants.find((variant) =>
            variant.options.every((opt, idx) => opt === selectedOptions[idx])
          );

          if (matchedVariant) {
            variantInput.value = matchedVariant.id;
            submitBtn.disabled = !matchedVariant.available;
          } else {
            variantInput.value = "";
            submitBtn.disabled = true;
          }
        };

        // Quantity buttons
        plusBtn?.addEventListener("click", () => {
          quantityInput.value = parseInt(quantityInput.value) + 1;
          qtyDisplay.textContent = quantityInput.value;
        });

        minusBtn?.addEventListener("click", () => {
          if (parseInt(quantityInput.value) > 1) {
            quantityInput.value = parseInt(quantityInput.value) - 1;
            qtyDisplay.textContent = quantityInput.value;
          }
        });

        // On form submit
        form.addEventListener("submit", function (e) {
          e.preventDefault();

          submitBtn.textContent = "Adding...";

          const formData = new FormData(form);

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json",
            },
            body: formData,
          })
            .then((response) => {
              if (!response.ok) throw new Error("Add to cart failed");
              return response.json();
            })
            .then((data) => {
              submitBtn.textContent = "Added!";
              //console.log("Data", data);

              return fetch("/cart?section_id=cart-icon-bubble");
            })
            .then((res) => res.text())
            .then((html) => {
              submitBtn.textContent = "Add to Bag";

              const parser = new DOMParser();
              const doc = parser.parseFromString(html, "text/html");
              const updatedBubble = doc.querySelector(".shopify-section");

              if (updatedBubble) {
                const target = document.querySelector(
                  "#cart-icon-bubble .shopify-section"
                );
                if (target) {
                  target.innerHTML = updatedBubble.innerHTML;
                } else {
                  const fallback = document.getElementById("cart-icon-bubble");
                  if (fallback) fallback.innerHTML = updatedBubble.innerHTML;
                }
              }

              if (typeof reInitCartDrawer === "function") reInitCartDrawer();

              if (cartType === "drawer") {
                // 🔓 Open the Dawn theme cart drawer
                const cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer && typeof cartDrawer.open === "function") {
                  cartDrawer.classList.remove("is-empty");
                  cartDrawer.open(); // ✅ This is the correct way in Dawn theme
                } else {
                  console.warn(
                    "Cart drawer not found or open method unavailable."
                  );
                }
              } else {
                // Fallback: redirect to cart page
                window.location.href = "/cart";
              }
            })
            .catch((err) => {
              console.error("Error adding to cart:", err);
              alert("There was an error adding the product to the cart.");
            });
        });

        // Trigger on load
        updateVariant();

        // Attach change listener to all selects
        form
          .querySelectorAll(".card__product-form-variant_container select")
          .forEach((select) => {
            select.addEventListener("change", updateVariant);
          });
      } else {
        //console.error("Product ID input not found!");
      }
    });
});

//Change Variant Image On Product Loop When Variant Change
document
  .querySelectorAll(".card__product-form-variant_container select")
  .forEach((select) => {
    select.addEventListener("change", function () {
      const form = this.closest("form");
      const productId = form.querySelector('input[name="productid"]').value;
      const variantDataEl = document.getElementById("ProductData-" + productId);

      if (!variantDataEl) return;

      const variants = JSON.parse(variantDataEl.textContent);

      // Collect selected options
      const selectedOptions = [...form.querySelectorAll("select")].map(
        (s) => s.value
      );

      // Match the correct variant
      const matchingVariant = variants.find((variant) =>
        variant.options.every((opt, i) => opt === selectedOptions[i])
      );

      if (matchingVariant && matchingVariant.featured_image) {
        const image = document.querySelector(
          `.product-card-image-${productId}`
        );
        const imgUrl = matchingVariant.featured_image.src;

        // Generate Shopify-style srcset with width variants
        const srcset = [165, 360, 533, 600]
          .map((w) => {
            return `${imgUrl}&width=${w} ${w}w`;
          })
          .join(",");

        image.src = `${imgUrl}&width=400`; // default fallback
        image.srcset = srcset;
      }
    });
  });

//Move product info above media for mobile
function moveProductInfoAboveMediaForMobile() {
  jQuery(function ($) {
    // Only run on mobile widths
    if (window.innerWidth >= 768) return;

    const $aboveMedia = $(".product-above-media");
    const $original = $(".product__info-wrapper .product-move-above-media");

    if (!$aboveMedia.length || !$original.length) return;

    // Clear existing content
    $aboveMedia.empty();

    // Clone and clean
    const $clone = $original.clone();
    $clone.find(".product-reviews-dummy-stars:not(.for-above-media)").remove();

    // Append and hide original
    $aboveMedia.append($clone);
    $original.hide();
  });
}

// Run on initial load
moveProductInfoAboveMediaForMobile();

// Optionally re-run on window resize (with debounce if needed)
$(window).on("resize", function () {
  moveProductInfoAboveMediaForMobile();
});

function moveDivsOnDesktop() {
  jQuery(function ($) {
    const isMobile = window.innerWidth < 768;

    $('.movable-div[data-move="true"]').each(function () {
      const $movableDiv = $(this);
      const showOnMobile =
        $movableDiv.data("show-on-mobile") === true ||
        $movableDiv.data("show-on-mobile") === "true";

      // Skip if mobile and not allowed
      if (isMobile && !showOnMobile) return;

      const targetSelector =
        $movableDiv.data("target") || ".product-info__move-target-div";
      const $targetDiv = $(targetSelector);

      if ($targetDiv.length) {
        $targetDiv.append($movableDiv);
      }
    });
  });
}

// Call it on load
moveDivsOnDesktop();

// Countdown offer - timer.
document.addEventListener("DOMContentLoaded", function () {
  const countdownTimers = document.querySelectorAll(
    ".product-info__countdown-offer-timer"
  );

  countdownTimers.forEach((timer) => {
    let targetTimestamp = parseInt(
      timer.getAttribute("data-target-timestamp"),
      10
    );

    // If no valid timestamp found, set it to 24 hours from now
    if (isNaN(targetTimestamp)) {
      const now = Math.floor(Date.now() / 1000); // current time in seconds
      targetTimestamp = now + 24 * 60 * 60; // add 24 hours
    }

    targetTimestamp = targetTimestamp * 1000; // convert to milliseconds

    const dayElem = timer.querySelector(
      ".product-info__countdown-offer-timer-days .font-heading"
    );
    const hourElem = timer.querySelector(
      ".product-info__countdown-offer-timer-hours .font-heading"
    );
    const minuteElem = timer.querySelector(
      ".product-info__countdown-offer-timer-minutes .font-heading"
    );
    const secondElem = timer.querySelector(
      ".product-info__countdown-offer-timer-seconds .font-heading"
    );

    function updateTimer() {
      const now = Date.now();
      const distance = targetTimestamp - now;

      if (distance <= 0) {
        dayElem.textContent = "00";
        hourElem.textContent = "00";
        minuteElem.textContent = "00";
        secondElem.textContent = "00";
        clearInterval(interval);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      dayElem.textContent = days.toString().padStart(2, "0");
      hourElem.textContent = hours.toString().padStart(2, "0");
      minuteElem.textContent = minutes.toString().padStart(2, "0");
      secondElem.textContent = seconds.toString().padStart(2, "0");
    }

    updateTimer(); // Initial call
    const interval = setInterval(updateTimer, 1000); // Update every second
  });
});

var PriceFormatter = {
  format: function (price) {
    if (!price) {
      return "";
    }

    price = String(price);
    price = price.padStart(3, "0");

    var amount = price.substr(0, price.length - 2);
    var decimals = price.substr(price.length - 2);

    // Build price.
    var value = "";
    if (PriceFormatter.currencySignAtStart) {
      value = PriceFormatter.currencySign;
    }

    if (amount.length > 3) {
      amount = PriceFormatter.stringReverse(amount);
      amount = amount.replace(
        /(.{3})/g,
        "$1" + PriceFormatter.thousandsSeparator
      );
      amount = PriceFormatter.stringReverse(amount);
    }

    value += amount;

    if (PriceFormatter.showDecimals) {
      value += PriceFormatter.decimalSeparator + decimals;
    }

    if (PriceFormatter.currencySignAtEnd) {
      value += PriceFormatter.currencySign;
    }

    return value;
  },

  stringReverse: function (s) {
    var o = "";
    for (var i = s.length - 1; i >= 0; i--) o += s[i];
    return o;
  },

  showPrice: function (parentQuery, price, comparePrice) {
    PriceFormatter.showPriceByElement($(parentQuery), price, comparePrice);
  },

  showPriceByElement: function (element, price, comparePrice) {
    element = $(element); // Fix: ensure it's a jQuery object

    price = Math.trunc(price);
    comparePrice = Math.trunc(comparePrice);

    if (price == comparePrice || PriceFormatter.showComparePrice == "no") {
       comparePrice = "";
    }

    element
      .find("span.price s")
      .attr("data-compare-price", comparePrice)
      .html(PriceFormatter.format(comparePrice));
    element
      .find("span.price span")
      .attr("data-price", price)
      .html(PriceFormatter.format(price));

    const taxRate = parseFloat(
      element.find("span.price_net").attr("data-tax-rate")
    );
    if (taxRate >= 0) {
      const netPrice = PriceFormatter.calculateNetPrice(price, taxRate);
      element.find("span.price_net span").html(PriceFormatter.format(netPrice));
    }
  },
  calculateNetPrice: function (price, taxRate) {
    return (price / (1 + taxRate)).toFixed(0);
  },
};

// Volume discount handling
document
  .querySelectorAll(".product-quantity-breaks-entry")
  .forEach(function (entry) {
    entry.addEventListener("click", function () {
      if (this.classList.contains("selected")) {
        return;
      }

      document
        .querySelectorAll(".product-quantity-breaks-entry")
        .forEach(function (e) {
          e.classList.remove("selected");
        });
      this.classList.add("selected");
    });
  });

// Click the first product quantity break entry by default
document.querySelector(".product-quantity-breaks-entry")?.click();

// Set / volume discount logic
if (document.querySelector(".product-quantity-breaks")) {
  document
    .querySelectorAll(
      ".product-quantity-breaks-entry-content-product-body-select select"
    )
    .forEach(function (select) {
      select.addEventListener("change", function () {
        var options = [];
        this.closest(".product-quantity-breaks-entry-content-product")
          .querySelectorAll("select")
          .forEach(function (selectElement) {
            options.push({
              key:
                "option" + (th_product.options.indexOf(selectElement.name) + 1),
              value: selectElement.value,
            });
          });

        var variant = th_product.variants.find(function (variant) {
          return options.every(function (values) {
            return variant[values.key] === values.value;
          });
        });

        if (!variant) return;

        // Update image
        if (variant.featured_image && variant.featured_image.src) {
          this.closest(".product-quantity-breaks-entry-content-product")
            .querySelector("img")
            .setAttribute("src", variant.featured_image.src);
        }

        // Update price
        var data = this.closest(".product-quantity-breaks-entry").dataset;
        var compareAtPrice = Math.trunc(
          variant.price * parseFloat(data.discount)
        );

        if (data.discountProductPrice && data.discountProductPrice !== "0") {
          compareAtPrice = data.discountProductPrice;
        }

        PriceFormatter.showPriceByElement(
          this.closest(
            ".product-quantity-breaks-entry-content-product-body"
          ).querySelector("h4"),
          compareAtPrice,
          data.useComparePrice ? variant.compare_at_price : variant.price
        );

        // Update total
        var total = 0;
        var totalCompare = 0;

        this.closest(".product-quantity-breaks-entry-content")
          .querySelectorAll("span.price:not(.hide)")
          .forEach(function (price) {
            totalCompare += parseInt(price.querySelector("span").dataset.price);
            total += parseInt(price.querySelector("s").dataset.comparePrice);
          });

       /* PriceFormatter.showPriceByElement(
          this.closest(".product-quantity-breaks-entry").querySelector(
            ".product-quantity-breaks-entry-header"
          ),
          totalCompare,
          total
        );*/

        // Handle sold out
        if (
          th_variantStock.hasOwnProperty(variant.id) &&
          th_variantStock[variant.id] === 0
        ) {
          this.closest(
            ".product-quantity-breaks-entry-content-product-body"
          ).querySelector(
            ".product-quantity-breaks-entry-content-product-body-out-of-stock"
          ).style.display = "flex";
          //document.getElementById("product-information-cart-button").disabled = true;
        } else {
          this.closest(
            ".product-quantity-breaks-entry-content-product-body"
          ).querySelector(
            ".product-quantity-breaks-entry-content-product-body-out-of-stock"
          ).style.display = "none";

          var displays = [];
          this.closest(".product-quantity-breaks-entry-content")
            .querySelectorAll(
              ".product-quantity-breaks-entry-content-product-body-out-of-stock"
            )
            .forEach(function (outOfStock) {
              displays.push(outOfStock.style.display);
            });

          if (!displays.includes("flex")) {
            //document.getElementById("product-information-cart-button").disabled = false;
          }
        }
      });
    });

  // Trigger the change event on the first select field to initialize
  document
    .querySelector(".product-quantity-breaks-entry select")
    ?.dispatchEvent(new Event("change"));
}

// Select field handling
document
  .querySelectorAll(".product-select-options span")
  .forEach(function (span) {
    span.addEventListener("click", function () {
      var selectElement =
        this.closest(".product-select").querySelector("select");
      this.closest(".product-select")
        .querySelectorAll("span")
        .forEach(function (s) {
          s.classList.remove("selected");
        });
      this.classList.add("selected");

      selectElement.value = this.textContent;
      this.closest(".product-select").querySelector(
        "label span:nth-child(2)"
      ).textContent = this.textContent;
    });
  });

// Select the first span by default
document.querySelector(".product-select-options span:first-child")?.click();

// Toggle select options display on label click
document
  .querySelectorAll(".product-select.button_box label")
  .forEach(function (label) {
    label.addEventListener("click", function () {
      var options = this.parentElement.querySelector(".product-select-options");

      if (options.style.display === "flex") {
        options.style.display = "none";
        this.querySelector("svg").style.transform = "rotate(0deg)";
      } else {
        options.style.display = "flex";
        this.querySelector("svg").style.transform = "rotate(90deg)";
      }
    });
  });

document.querySelectorAll(".product-form__submit").forEach((button) => {
  button.addEventListener("click", () => {
    const form = button.closest("form");

    // Clean previously injected fields
    form.querySelectorAll(".injected-property").forEach((el) => el.remove());

    // Inject external properties for inputs, selects, textareas, checkboxes, radio buttons, and file uploads
    document
      .querySelectorAll(
        'input[name^="properties["], select[name^="properties["], textarea[name^="properties["], input[type="file"][name^="properties["]'
      )
      .forEach((input) => {
        const hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = input.name;

        // Handle different input types
        if (input.type === "checkbox") {
          hidden.value = input.checked ? input.value : ""; // Handle checkbox state
        } else if (input.type === "radio") {
          if (input.checked) {
            hidden.value = input.value; // Handle selected radio button
          }
        } else if (input.type === "file") {
          hidden.value = input.files.length > 0 ? input.files[0].name : ""; // Handle file upload input (file name)
        } else {
          hidden.value = input.value; // Default for other types (input, textarea, select)
        }

        hidden.classList.add("injected-property");
        form.appendChild(hidden);
      });
  });
});

//Product file type select
document.querySelectorAll(".product-select").forEach((selectBox) => {
  const select = selectBox.querySelector("select");
  const optionButtons = selectBox.querySelectorAll(
    ".product-select-options span"
  );

  // Open/close options on label click
  selectBox.querySelector("label").addEventListener("click", (e) => {
    e.preventDefault();
    selectBox.classList.toggle("dropdown");
  });

  // Handle selecting an option
  optionButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      // Remove "selected" class from all
      optionButtons.forEach((el) => el.classList.remove("selected"));

      // Add to the clicked one
      btn.classList.add("selected");

      // Update the hidden <select> value
      const value = btn.textContent.trim();
      select.value = value;

      // Log the selected value to console
      //console.log("Selected Value:", value);

      // Trigger change event if needed
      select.dispatchEvent(new Event("change"));

      // Close the dropdown
      selectBox.classList.remove("dropdown");
    });
  });
});

//Product Media Show More/Show Less
function toggleMedia() {
  const hiddenImages = document.querySelectorAll(".hidden-extra");
  const showMoreText = document.getElementById("show-more-text");
  const arrowIcon = document.getElementById("arrow-icon");

  // Toggle visibility of the hidden images
  hiddenImages.forEach((image) => image.classList.toggle("hidden"));

  // Update button text to Show Less or Show More
  if (showMoreText.textContent.trim() === "Show More") {
    showMoreText.textContent = "Show Less";
  } else {
    showMoreText.textContent = "Show More";
  }

  // Rotate the arrow icon
  arrowIcon.classList.toggle("rotate-180");
}

//Footer links collapsible

function toggleFooterMenu(header) {
  const list = header.nextElementSibling;
  const icon = header.querySelector(".icon-symbol");
  const expanded = header.getAttribute("aria-expanded") === "true";

  header.setAttribute("aria-expanded", !expanded);
  list.classList.toggle("open");
  icon.textContent = expanded ? "+" : "−";
}

//Footer Bottom Class Remove Add On Mobile Desktop

document.addEventListener("DOMContentLoaded", function () {
  const footer = document.getElementById("footer-bottom");

  if (!footer) return;

  // Save original color- class
  let originalColorClass = null;
  footer.classList.forEach((cls) => {
    if (cls.startsWith("color-")) {
      originalColorClass = cls;
    }
  });

  function toggleColorSchemeClass() {
    const isMobile = window.innerWidth < 768;

    if (originalColorClass) {
      if (isMobile) {
        footer.classList.remove(originalColorClass);
      } else {
        if (!footer.classList.contains(originalColorClass)) {
          footer.classList.add(originalColorClass);
        }
      }
    }
  }

  // Initial run
  toggleColorSchemeClass();

  // Run on resize
  window.addEventListener("resize", toggleColorSchemeClass);
});

// Swiper Sliders JS

function toggleResponsiveSwiper(selector) {
  const containers = document.querySelectorAll(selector);

  containers.forEach((container) => {
    const sectionId = container.dataset.sectionId;
    const enableMobile = container.dataset.sliderEnableMobile === "true";
    const enableDesktop = container.dataset.sliderEnableDesktop === "true";
    const defaultClass = container.dataset.defaultClass || ""; // Fallback to empty string if undefined

    const updateClasses = () => {
      const isMobile = window.innerWidth <= 768;
      const isDesktop = window.innerWidth > 768;

      const enableOnMobileOnly = enableMobile && !enableDesktop;
      const enableOnDesktopOnly = !enableMobile && enableDesktop;
      const enableOnBoth = enableMobile && enableDesktop;

      const shouldEnableSwiper =
        (isMobile && enableOnMobileOnly) ||
        (isDesktop && enableOnDesktopOnly) ||
        enableOnBoth;

      container.className = ""; // clear all classes first

      if (shouldEnableSwiper) {
        container.classList.add(
          "swiper-wrapper",
          `swiper-wrapper-${sectionId}`
        );
      } else {
        // Ensure that defaultClass is a string and split it safely
        (defaultClass || "").split(" ").forEach((cls) => {
          if (cls.trim()) container.classList.add(cls.trim());
        });
      }
    };

    updateClasses();
    window.addEventListener("resize", () => setTimeout(updateClasses, 200));
  });
}

function toggleResponsiveSlides(selector) {
  const slides = document.querySelectorAll(selector);

  slides.forEach((slide) => {
    const sectionId = slide.dataset.sectionId;
    const defaultClass = slide.dataset.defaultClass || ""; // Fallback to empty string if undefined
    const enableMobile =
      document.querySelector(`[data-section-id="${sectionId}"]`)?.dataset
        .sliderEnableMobile === "true";
    const enableDesktop =
      document.querySelector(`[data-section-id="${sectionId}"]`)?.dataset
        .sliderEnableDesktop === "true";

    const updateSlideClass = () => {
      const isMobile = window.innerWidth <= 768;
      const isDesktop = window.innerWidth > 768;

      const enableOnMobileOnly = enableMobile && !enableDesktop;
      const enableOnDesktopOnly = !enableMobile && enableDesktop;
      const enableOnBoth = enableMobile && enableDesktop;

      const shouldEnableSwiper =
        (isMobile && enableOnMobileOnly) ||
        (isDesktop && enableOnDesktopOnly) ||
        enableOnBoth;

      // Reset class
      slide.className = "";

      if (shouldEnableSwiper) {
        slide.classList.add("swiper-slide", `swiper-slide-${sectionId}`);
      } else {
        // Ensure that defaultClass is a string and split it safely
        (defaultClass || "").split(" ").forEach((cls) => {
          if (cls.trim()) slide.classList.add(cls.trim());
        });
      }

      // Restore cascade data/style if needed
      if (slide.hasAttribute("data-cascade")) {
        slide.style.setProperty("--animation-order", slide.dataset.slideIndex);
      }
    };

    updateSlideClass();
    window.addEventListener("resize", () => setTimeout(updateSlideClass, 200));
  });
}

// Usage
//toggleResponsiveSwiper('[id^="Slider-"]');
//toggleResponsiveSlides('[id^="Slide-"]');

const swiperInstances = {};

function initResponsiveSwiper(containerSelector) {
  document.querySelectorAll(containerSelector).forEach((container) => {
    const id = container.dataset.sectionId;
    const swiperSectionID = `Swiper-${id}`;
    const swiperSelector = container.dataset.swiperContainer;

    const wrapperId = container.dataset.swiperWrapperId;
    const swiperSlideId = `Slide-${id}`;

    //toggleResponsiveSwiper('[id^="Slider-"]');
    toggleResponsiveSwiper(`#${wrapperId}`);
    //toggleResponsiveSlides('[id^="Slide-"]');

    //console.log(swiperSlideId);
    toggleResponsiveSlides(`[id^="${swiperSlideId}"]`);

    // Check if swiperSelector exists
    if (!swiperSelector) {
      console.warn("Missing swiperSelector for section:", id);
      return;
    }

    const enableMobile = container.dataset.sliderEnableMobile === "true";
    const enableDesktop = container.dataset.sliderEnableDesktop === "true";

    const isMobile = window.innerWidth <= 768;
    const isDesktop = window.innerWidth > 768;

    const enableOnMobileOnly = enableMobile && !enableDesktop;
    const enableOnDesktopOnly = !enableMobile && enableDesktop;
    const enableOnBoth = enableMobile && enableDesktop;

    const shouldEnableSwiper =
      (isMobile && enableOnMobileOnly) ||
      (isDesktop && enableOnDesktopOnly) ||
      enableOnBoth;

    const swiperEl = document.querySelector(swiperSelector);

    // Ensure the swiperEl exists before proceeding
    if (!swiperEl) {
      //console.warn("Swiper container not found:", swiperSelector);
      return;
    }

    // Destroy existing instance if any
    if (swiperInstances[id]) {
      swiperInstances[id].destroy(true, true);
      swiperInstances[id] = null;
    }

    // Remove or add swiper-wrapper class
    if (shouldEnableSwiper) {
      container.classList.add("swiper-wrapper", `swiper-wrapper-${id}`);

      // Create new swiper instance
      swiperInstances[id] = new Swiper(swiperSelector, {
        speed: Number(container.dataset.speed),
        spaceBetween: Number(container.dataset.spaceBetween),
        effect: container.dataset.effect,
        loop: container.dataset.loop === "true",
        centeredSlides: container.dataset.centeredSlides === "true",
        direction: container.dataset.direction,
        initialSlide: Number(container.dataset.initialSlide),
        slidesPerView: Number(container.dataset.slidesPerView),
        slidesPerGroup: Number(container.dataset.slidesPerGroup),
        a11y: true,
        grabCursor: false,
        watchOverflow: true,
        autoplay: {
          delay: Number(container.dataset.autoplayDelay),
          disableOnInteraction: false,
          pauseOnMouseEnter: container.dataset.pauseOnHover === "true",
        },
        pagination: {
          el: container.dataset.pagination,
          clickable: true,
          type: container.dataset.paginationType,
        },
        navigation: {
          nextEl: container.dataset.navNext,
          prevEl: container.dataset.navPrev,
        },
        scrollbar: {
          el: container.dataset.scrollbar,
          draggable: true,
        },
        keyboard: {
          enabled: container.dataset.keyboardEnabled === "true",
          onlyInViewport: true,
        },
        breakpoints: {
          0: {
            slidesPerView: Number(container.dataset.slidesMobile),
          },
          576: {
            slidesPerView: Number(container.dataset.slidesMobile),
          },
          768: {
            slidesPerView: Number(container.dataset.slidesTablet),
          },
          1024: {
            slidesPerView: Number(container.dataset.slidesPerView),
          },
        },
      });
    } else {
      container.classList.remove("swiper-wrapper", `swiper-wrapper-${id}`);
    }
  });
}

// Initialize on load and resize
document.addEventListener("DOMContentLoaded", () => {
  initResponsiveSwiper("[data-swiper-container]");
  window.addEventListener("resize", () => {
    setTimeout(() => initResponsiveSwiper("[data-swiper-container]"), 300);
  });
});

//Header Menu Dropdown Open/Close on hover
document.querySelectorAll("nav.header__inline-menu li").forEach((li) => {
  const details = li.querySelector("details");
  if (!details) return;

  li.addEventListener("mouseenter", () => {
    details.setAttribute("open", true);
  });

  li.addEventListener("mouseleave", () => {
    details.removeAttribute("open");
  });
});

//License

(function() {
  const COOKIE_NAME = 'trial_start';
  const TRIAL_DAYS = 14;
  const POPUP_THRESHOLD_DAYS = 14;
  const LICENSE_URL = 'https://your-license-page.com'; // Replace with your actual URL

  // Only run if embedded in Shopify Admin (iframe inside Shopify admin)
  const isShopifyAdmin = window.top !== window.self;

  if (!isShopifyAdmin) return;

  function setCookie(name, value, daysValid) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (daysValid * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  function getCookie(name) {
    const value = document.cookie
      .split('; ')
      .find(row => row.startsWith(name + '='));
    return value ? value.split('=')[1] : null;
  }

  function getRemainingTime(startDateStr) {
    const startDate = new Date(startDateStr);
    const now = new Date();
    const elapsedMs = now - startDate;
    return TRIAL_DAYS * 24 * 60 * 60 * 1000 - elapsedMs;
  }

  function formatTime(ms) {
    const days = Math.floor(ms / (1000 * 60 * 60 * 24));
    const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const seconds = Math.floor((ms / 1000) % 60);
    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  function disableAdminEditing() {
    const selectors = 'input, textarea, select, button, [contenteditable]';
    document.querySelectorAll(selectors).forEach(el => {
      el.disabled = true;
      el.style.pointerEvents = 'none';
      el.style.opacity = '0.6';
    });

    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = 0;
    overlay.style.left = 0;
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(255,255,255,0.9)';
    overlay.style.zIndex = '9999';
    overlay.style.display = 'flex';
    overlay.style.justifyContent = 'center';
    overlay.style.alignItems = 'center';
    overlay.innerHTML = '<div style="text-align:center;font-size:20px;font-weight:bold;">Your 14-day trial has expired.<br>Please activate your license to continue editing.</div>';
    document.body.appendChild(overlay);
  }

  function showTrialPopup(msRemaining) {
    const popup = document.createElement('div');
    popup.id = 'trial-timer-popup';
    popup.style.position = 'fixed';
    popup.style.bottom = '20px';
    popup.style.right = '20px';
    popup.style.padding = '15px 20px';
    popup.style.backgroundColor = '#fff';
    popup.style.border = '1px solid #ccc';
    popup.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
    popup.style.zIndex = '9999';
    popup.style.fontSize = '14px';
    popup.style.borderRadius = '6px';
    popup.innerHTML = `
      <div style="margin-bottom: 8px;">
        <strong>Trial expires in:</strong> <span id="trial-countdown">${formatTime(msRemaining)}</span>
      </div>
      <a href="${LICENSE_URL}" target="_blank" style="color: #007bff; text-decoration: none;">Buy License</a>
      <button id="close-trial-popup" style="margin-left: 10px; background: transparent; border: none; font-weight: bold; cursor: pointer;">×</button>
    `;

    document.body.appendChild(popup);

    document.getElementById('close-trial-popup').onclick = () => {
      popup.remove();
    };

    const countdownEl = document.getElementById('trial-countdown');
    const interval = setInterval(() => {
      msRemaining -= 1000;
      if (msRemaining <= 0) {
        countdownEl.textContent = 'Expired';
        clearInterval(interval);
      } else {
        countdownEl.textContent = formatTime(msRemaining);
      }
    }, 1000);
  }

  // Initialization
  let trialStart = getCookie(COOKIE_NAME);
  if (!trialStart) {
    const today = new Date().toISOString().split('T')[0];
    setCookie(COOKIE_NAME, today, 365); // long duration, trial still only 14 days
    trialStart = today;
  }

  const remainingMs = getRemainingTime(trialStart);
  const remainingDays = Math.floor(remainingMs / (1000 * 60 * 60 * 24));

  if (remainingMs <= 0) {
    disableAdminEditing();
  } else if (remainingDays <= POPUP_THRESHOLD_DAYS) {
    showTrialPopup(remainingMs);
  }
})();

document.addEventListener('lazybeforeunveil', function(e) {
  var video = e.target.tagName === 'VIDEO' ? e.target : e.target.querySelector('video');
  if (video) {
    video.querySelectorAll('source').forEach(function(source) {
      if (source.dataset.src) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      }
    });
    video.load();
    video.play().catch(function() {
      console.log('Video playback failed, likely due to browser restrictions.');
    });
  }
});




document.addEventListener('DOMContentLoaded', () => {
  // Select all video elements
  const videos = document.querySelectorAll('video');

  // Create an Intersection Observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          // Play video when in viewport
          video.play().catch((error) => {
            console.error('Error playing video:', error);
          });
        } else {
          // Pause video and reset to start when out of viewport
          video.pause();
          video.currentTime = 0; // Optional: Reset to start
        }
      });
    },
    {
      threshold: 0.5, // Play when 50% of the video is visible
    }
  );

  // Observe each video
  videos.forEach((video) => {
    observer.observe(video);
  });
});


// Add to your theme.js or a custom script in Shopify theme editor
// This runs when customer lands on your store with ?status=...&store=...

// Paste in your Shopify theme → Edit code → theme.js (or a custom snippet)
(function () {
    console.log('Script started');

    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    const store  = params.get('store');

    console.log('URL Params:', {
        status: status,
        store: store
    });

    if (!status || !store) {
        console.warn('Missing status or store, stopping execution');
        return;
    }

    console.log('Sending request to /cart/update.js...');

    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            attributes: {
                'license_status': status,
                'license_store': store
            }
        })
    })
    .then(response => {
        console.log('Response received:', response);
        return response.json();
    })
    .then(data => {
        console.log('Cart updated successfully:', data);
    })
    .catch(error => {
        console.error('Error updating cart:', error);
    });

})();